// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  

  // dev
  // baseUrl: 'https://devapi.tulipfin.com', 
  // docUrl: 'https://devdoc.tulipfin.com',
  // // panUrl: 'https://devtulipapi.tulipfin.com',
  // panUrl: 'https://devcam.tulipfin.com',
  // kycUrl: 'https://devapi.tulipfin.com',
  // docDel: 'https://devdoc.tulipfin.com',
  // notifyUrl: 'https://devnotify.tulipfin.com',
  
  // payUrl: 'https://devpayment.tulipfin.com',

//prod
baseUrl: 'https://api.tulipfin.com', 
docUrl: 'https://doc.tulipfin.com',
panUrl: 'https://tulipapi.tulipfin.com',
kycUrl: 'https://api.tulipfin.com',
notifyUrl: 'https://notify.tulipfin.com',
docDel: 'https://doc.tulipfin.com',
payUrl: 'https://devpayment.tulipfin.com',  
 
  explorerUrl: 'https://explorerapi.tulipfin.com',
  firebase: {
    apiKey: 'AIzaSyB-eHmAUZWB2l2Xuxy_R2JVYAXmIemjpMc',
    authDomain: 'tulipfinnotify.firebaseapp.com',
    databaseURL: 'https://tulipfinnotify.firebaseio.com',
    projectId: 'tulipfinnotify',
    storageBucket: 'tulipfinnotify.appspot.com',
    messagingSenderId: '583685801267'
    // apiKey: 'AIzaSyALm3pZ4ue0kjd9JhwddEHerIQMlFch7-c',
    // authDomain: 'invoizo-prod.firebaseapp.com',
    // databaseURL: 'https://invoizo-prod.firebaseio.com',
    // projectId: 'invoizo-prod',
    // storageBucket: 'invoizo-prod.appspot.com',
    // messagingSenderId: '443427559070',
  },

  RazorpayApiKey: "rzp_test_zsvtDlpbBb3lDI",
  RazorpayCallbackURL: "",
  RazorpayCompanyLogo: "",

};

// export const environment = {
//   production: false,
//   baseUrl: 'http://103.67.236.96:5020',
//   docUrl: 'http://103.67.236.96:5032',
//   notifyUrl: 'http://103.67.236.96:5021'
// };

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
